import Vue from "vue";
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import router from "./router";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "./assets/css/index.less";

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

document.title = "安博腾生物科技有限公司"

new Vue({
    router,
    render: h => h(App)
}).$mount("#app");
